import { Component, computed, input } from '@angular/core';
import { AdditionalProductsSummaryPoint, Address, IERechnungsInfo, SummaryContractInfo, TextNodeType } from '@mwe/models';
import { getAddressGroupFormatted } from '@mwe/utils';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';
import { TranslatePipe } from '@ngx-translate/core';
import { InfoboxComponent } from '../../infobox/infobox.component';
import { NewBankAccountInfoTextsComponent } from '../../bank/new-bank-account-info-texts/new-bank-account-info-texts.component';
import { ProductSummaryContractInfoComponent } from '../products-summary/product-summary-contract-info.component';
import { HeadlineComponent } from '../../headline/headline.component';
import { SafeHtmlPipe } from '@mwe/ui/pipes';
import { MwSharedLibsModule } from '@mwe/ui/shared';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'mwe-summary-invoice',
  templateUrl: './summary-invoice.component.html',
  imports: [
    BasicCardComponent,
    InfoboxComponent,
    NewBankAccountInfoTextsComponent,
    TranslatePipe,
    ProductSummaryContractInfoComponent,
    HeadlineComponent,
    SafeHtmlPipe,
    MwSharedLibsModule,
    NgTemplateOutlet,
  ],
})
export class SummaryInvoiceComponent {
  readonly cardTitle = input<string>('');
  readonly paymentIcon = input<string>('');
  readonly paymentText = input<string>('');
  readonly eRechnungInfo = input<IERechnungsInfo>(null);
  readonly invoiceAddress = input<Address>(null);
  readonly areBankAccountInfoTextsVisible = input<boolean>(false);
  readonly contractInfos = input<SummaryContractInfo[]>(null);
  readonly showBankAccountInfoTextAsAlert = input<boolean>(false);
  readonly invoiceInfoAlertMessage = input<string>('');
  readonly paymentInfo = input<string>('');
  readonly productCategories = input<string[]>();
  readonly additionalBulletPoints? = input<AdditionalProductsSummaryPoint[]>([]);
  readonly hasSpotTariff = input<boolean>(false);
  readonly emailMessageInfoKey = input<string>('');
  readonly email = input<string>('');
  readonly headingNodeType = input<TextNodeType>('p');
  readonly useSplitCardsDesign = input<boolean>(false); /** Splits Contract data and Invoice data into separate cards */
  readonly billingCardTitle = input<string>(''); /** Only applicable for split card design */
  readonly personalDataTitle = input<string>(''); /** Only applicable for split card design */

  readonly formattedInvoiceAddress = computed<string>(() => getAddressGroupFormatted(this.invoiceAddress(), true));
  readonly singleCardIcon = computed<string>(() =>
    this.email() ? 'fa-file-user' : this.contractInfos()?.length ? 'fa-file-lines' : 'fa-envelope-open-text',
  ); /** Only applicable for single card design */
}
